import React from 'react'

import { InsightOpportunity } from 'modules/accountActivity/domain'

import BaseCard from '../BaseCard'
import { CardHeader,CardHeaderExpandProps } from '../CardHeader'
import EmptyCardText from '../EmptyCardText'
import { MemoReadonlyField } from '../Fields'

import styles from './styles.module.css'

export const DetailsCardHeader: React.FC<CardHeaderExpandProps> = ({ ...rest }) => {
  return (
    <CardHeader
      data-ocweb-id="DealDetailsCardHeader"
      content={
        <div className={styles.headerContent}>
          <div>Details</div>
        </div>
      }
      {...rest}
    />
  )
}

interface DetailsCardProps {
  deal?: InsightOpportunity
}

export const DetailsCard: React.FC<DetailsCardProps> = ({ deal }) => {
  const hasDataToDisplay = true
  return (
    <BaseCard data-ocweb-id="CompanyCard">
      {!hasDataToDisplay ? (
        <EmptyCardText
          data-ocweb-id="EmptyCompanyText"
          content="We don't have any details for this deal"
        />
      ) : (
        <>
          <MemoReadonlyField
            className={styles.datum}
            label="Account name"
            value={deal?.accountName}
            displayWrap
          />

          <MemoReadonlyField
            className={styles.datum}
            label="Lead source"
            value={deal?.leadSource}
            displayWrap
          />
          <MemoReadonlyField
            className={styles.datum}
            label="Description"
            value={deal?.description}
            displayWrap
          />
          <MemoReadonlyField
            className={styles.datum}
            label="Next steps"
            value={deal?.nextStep}
            displayWrap
          />
        </>
      )}
    </BaseCard>
  )
}

export default DetailsCard
